module.exports = __webpack_public_path__ + "img/feature_camera.53cc7ca7.png";